import { FC,Dispatch } from 'react';
import { Setting } from '../../App';
import classes from '../../asset/css/subscription-detail/product-list-pickup.module.css';
import { ProductInfoViewType, ProductItemPickUpType } from '../../types/view/product-info-view-type';
import { RecommendProductInfoViewType } from '../../types/view/recommend-product-info-view-type';
import { ProductItemPickup } from './ProductItemPickup';
import { SubscriptionType } from '../../types/api/subscriptions-api-type';

export const ProductListPickup: FC<{
  pickUpProducts: ProductItemPickUpType[];
  loading: boolean;
  setting: Setting;
  addProductSuccess: (showModal: boolean) => void;
  failed: (message: string) => void;
  setSubscriptionContractId: Dispatch<string>;
  setRegisteredProducts: Dispatch<ProductInfoViewType[]>;
  setPausedProducts: Dispatch<ProductInfoViewType[]>;
  setRecommendProducts: Dispatch<RecommendProductInfoViewType[]>;
  setSubscription: Dispatch<SubscriptionType>
}> = ({
  pickUpProducts,
  loading,
  setting,
  addProductSuccess,
  failed,
  setSubscriptionContractId,
  setPausedProducts,
  setRecommendProducts,
  setRegisteredProducts,
  setSubscription
}) => {

  if (pickUpProducts.length === 0) {
    return <></>;
  }

  return (
    <div className={classes.pickup}>
      <h2 className={classes.pickup_heading}>
        <span className={classes.pickup_heading_label}>ピックアップ商品</span>
      </h2>
      <ul className={classes.pickup_list}>
        {/* 3件のみ表示 */}
        {pickUpProducts.slice(0, 3).map((product, index) => (
          <ProductItemPickup
            key={`pickupItem_${index}`}
            loading={loading}
            productItem={product}
            message={product.message}
            setting={setting}
            addProductSuccess={addProductSuccess}
            failed={failed}
            setSubscriptionContractId={setSubscriptionContractId}
            setRegisteredProducts={setRegisteredProducts}
            setPausedProducts={setPausedProducts}
            setRecommendProducts={setRecommendProducts}
            setSubscription={setSubscription}
          />
        ))}
      </ul>
    </div>
  );
};
